"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var RetryPaymentAction_1 = require("./actions/RetryPaymentAction");
var MarkRefundAsPaidAction_1 = require("./actions/MarkRefundAsPaidAction");
var WriteOffInvoiceAction_1 = require("./actions/WriteOffInvoiceAction");
var InvoicesTable = /** @class */ (function (_super) {
    __extends(InvoicesTable, _super);
    function InvoicesTable(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.renderInvoicesTable = function (invoices) {
            var invoicesToRender = invoices.results.filter(function (i) { return i.statusCode !== "OBSOLETE"; });
            return invoicesToRender.map(function (invoice) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: invoice.id }), (0, jsx_runtime_1.jsxs)("td", { children: [moment(invoice.dueDate).format("Do MMMM YYYY"), " ", (0, jsx_runtime_1.jsx)("br", {}), invoice.delayedDueDate && (0, jsx_runtime_1.jsxs)("span", { className: "text-danger", children: ["(delayed to ", moment(invoice.delayedDueDate).format("Do MMMM YYYY"), ")"] })] }), (0, jsx_runtime_1.jsx)("td", { children: (0, commonFunctions_1.getAmountToDisplay)(invoice.amount) }), (0, jsx_runtime_1.jsx)("td", { children: _this.renderPolicyNumbers(invoice.policies) }), (0, jsx_runtime_1.jsx)("td", { children: _this.renderVersionAndType(invoice) }), (0, jsx_runtime_1.jsx)("td", { children: invoice.statusText }), (0, jsx_runtime_1.jsx)("td", { children: _this.renderPaymentMade(invoice) }), _this.templates.userHasRole(["Administrator", "CSR_Lead", "CSR", "Support"]) &&
                        (0, jsx_runtime_1.jsxs)("td", { children: [invoice.statusCode === "PENDING_PAYMENT" && new Date(invoice.dueDate) <= new Date() && (invoice.amount > 0) && _this.props.updatedInvoiceId !== invoice.id &&
                                    (0, jsx_runtime_1.jsx)(RetryPaymentAction_1.default, { customerReferenceNumber: _this.props.customerReferenceNumber, invoice: invoice, getInvoiceAndPaymentData: _this.props.getInvoiceAndPaymentData, setUpdatedInvoiceId: _this.props.setUpdatedInvoiceId }), invoice.statusCode === "PENDING_PAYMENT" && _this.isEligibleForWriteOff(invoice) && _this.isEligibleUser() &&
                                    (0, jsx_runtime_1.jsx)(WriteOffInvoiceAction_1.default, { customerReferenceNumber: _this.props.customerReferenceNumber, policyNumber: invoice.policies[0], invoice: invoice, getInvoiceAndPaymentData: _this.props.getInvoiceAndPaymentData, setUpdatedInvoiceId: _this.props.setUpdatedInvoiceId }), invoice.statusCode === "PENDING_PAYMENT" && invoice.isRefundOrGoodwill && (invoice.latestTransactionReasonCode === '0000') &&
                                    (0, jsx_runtime_1.jsx)(MarkRefundAsPaidAction_1.default, { invoiceId: invoice.id, policyNumber: invoice.policies[0], customerReferenceNumber: _this.props.customerReferenceNumber, getInvoiceAndPaymentData: _this.props.getInvoiceAndPaymentData }, "Mark refund as PAID action")] })] }, invoice.id)); });
        };
        _this.renderPolicyNumbers = function (policies) {
            return policies.map(function (policyNumber, index) {
                if (index === policies.length - 1) {
                    return policyNumber;
                }
                else {
                    return policyNumber + ", ";
                }
            });
        };
        _this.renderPaymentMade = function (invoice) {
            if (invoice.statusCode === "PAID" || invoice.statusCode === "PARTIALY_PAID") {
                return "Y";
            }
            else if (new Date(invoice.dueDate) > new Date() || invoice.statusCode === "WRITTEN_OFF") {
                return "";
            }
            else {
                return "N";
            }
        };
        _this.renderVersionAndType = function (invoice) {
            return "V" + invoice.policyVersionNumber + " - " + (0, commonFunctions_1.policyTypeName)(invoice.type);
        };
        return _this;
    }
    InvoicesTable.prototype.render = function () {
        if (this.props.loading) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else {
            if (this.props.invoices && this.props.invoices.count > 0) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "row mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "table-responsive panel-border px-4", children: [(0, jsx_runtime_1.jsx)("b", { className: "pl-2", children: "Invoices:" }), (0, jsx_runtime_1.jsxs)("table", { className: "table table-hover table-sm table-bordered", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { className: "table-active", children: [(0, jsx_runtime_1.jsx)("th", { children: "Invoice Nr:" }), (0, jsx_runtime_1.jsx)("th", { children: "Due date:" }), (0, jsx_runtime_1.jsx)("th", { children: "Amount:" }), (0, jsx_runtime_1.jsx)("th", { children: "Policy Number:" }), (0, jsx_runtime_1.jsx)("th", { children: "Version and type:" }), (0, jsx_runtime_1.jsx)("th", { children: "Invoice Status:" }), (0, jsx_runtime_1.jsx)("th", { children: "Payment Made:" }), this.templates.userHasRole(["Administrator", "CSR_Lead", "CSR", "Support"]) &&
                                                    (0, jsx_runtime_1.jsx)("th", { children: "Actions:" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderInvoicesTable(this.props.invoices) })] })] }) }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("h3", { className: "panel-border px-4", children: "Invoices not found!" });
            }
        }
    };
    InvoicesTable.prototype.isEligibleForWriteOff = function (invoice) {
        return invoice.amount > 0 && !invoice.isRefundOrGoodwill;
    };
    InvoicesTable.prototype.isEligibleUser = function () {
        return this.templates.userHasRole(["Administrator", "CSR_Lead"]);
    };
    InvoicesTable = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InvoicesTable);
    return InvoicesTable;
}(React.Component));
exports.default = InvoicesTable;
//# sourceMappingURL=InvoicesTable.js.map